<template>
  <div class="allOrders">
    <SearchHeader @results="searchResults = $event" />
    <v-tabs
      v-if="!searchResults"
      v-model="category" centered class="mt-4 mb-2" background-color="transparent"
    >
      <v-tab :value="categories.ALL">All Orders</v-tab>
      <v-tab :value="categories.DELAYED_FULFILL">Delayed Fulfill</v-tab>
      <v-tab :value="categories.DELAYED_SHIPMENT">Delayed Shipment</v-tab>
    </v-tabs>
    <div v-else class="mt-4 mb-2 searchResultInfo">
      {{ searchResults.length }} Treffer — Feld leeren für die normale Liste
    </div>
    <OrdersTable :orders="searchResults || orders" :loading="loadingOrders" />
  </div>
</template>

<script>
import SearchHeader from "@/components/AllOrders/components/SearchHeader";
import { mapActions, mapGetters, mapMutations } from "vuex";
import OrdersTable from "@/components/AllOrders/components/OrdersTable";
import { orderFilterCategories } from "@/constants";
export default {
  name: "AllOrders",
  components: { OrdersTable, SearchHeader },
  data() {
    return {
      searchResults: null,
    };
  },
  computed: {
    ...mapGetters(["orders", "loadingOrders", "filterCategory"]),
    category: {
      get() {
        return this.filterCategory;
      },
      set(value) {
        this.setFilterCategory(value);
      },
    },
    categories() {
      return orderFilterCategories;
    },
  },
  mounted() {
    this.setFilterOrderId("");
    this.setFilterEmail("");
    this.setFilterQuickSearch("");
    this.loadAllOrders();
  },
  watch: {
    category() {
      this.loadAllOrders();
    },
  },
  methods: {
    ...mapActions(["loadAllOrders"]),
    ...mapMutations([
      "setFilterCategory",
      "setFilterOrderId",
      "setFilterEmail",
      "setFilterQuickSearch",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.search-error {
  color: #d70000;
}

.searchResultInfo {
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.5);
  padding: 10px;
}
</style>
